import { CharacterBadgeConfig } from '@/types/characterBadgeConfig'

export const buildCharacterBadgeConfigMap = (
  configs?: CharacterBadgeConfig[]
) =>
  new Map(
    (configs || [])
      .filter(
        (config) =>
          config.badge_id &&
          config.icon_type === 'asset' &&
          Boolean(config.icon_value)
      )
      .map((config) => [config.badge_id, config])
  )

export const getCharacterDisplayBadge = (
  badges?: string[] | null,
  badgeConfigMap?: Map<string, CharacterBadgeConfig>
) => {
  if (!badges || badges.length === 0 || !badgeConfigMap) return undefined

  let displayBadge: CharacterBadgeConfig | undefined
  for (const badgeID of badges) {
    const config = badgeConfigMap.get(badgeID)
    if (!config) continue
    if (!displayBadge || config.priority > displayBadge.priority) {
      displayBadge = config
    }
  }

  return displayBadge
}
